;
(function (ng) {
  'use strict';

  angular.module('input', []);
})(window.angular);